const teamMembers = {
    pageTitle: {
        ja: "\u30E1\u30F3\u30D0\u30FC\u7D39\u4ECB | \u682A\u5F0F\u4F1A\u793ENAPIRE",
        en: "Team | NAPIRE Inc."
    },
    metaDescription: {
        ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE\u306E\u30E1\u30F3\u30D0\u30FC\u7D39\u4ECB\u3002\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30C6\u30A3\u30B9\u30C8\u30FB\u30A8\u30F3\u30B8\u30CB\u30A2\u30FBPM\u306E\u7565\u6B74\u3068\u4E3B\u8981\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002",
        en: "Meet the NAPIRE team\u2014bios and project track records across AI, cloud, and engineering."
    },
    metaKeywords: {
        ja: "NAPIRE,\u30E1\u30F3\u30D0\u30FC,\u30C1\u30FC\u30E0,\u30A8\u30F3\u30B8\u30CB\u30A2,PM,AI,\u30AF\u30E9\u30A6\u30C9,\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E",
        en: "NAPIRE,team,members,engineers,PM,AI,cloud,project track record"
    },
    hero: {
        eyebrow: {
            ja: "Team",
            en: "Team"
        },
        title: {
            ja: "\u30E1\u30F3\u30D0\u30FC\u7D39\u4ECB",
            en: "Our team"
        },
        lead: {
            ja: "\u5F79\u5272\u30FB\u7565\u6B74\u30FB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E\u3092\u4E2D\u5FC3\u306B\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002\u5C02\u9580\u6027\u3068\u5B9F\u7E3E\u304B\u3089\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u95A2\u308F\u308A\u65B9\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
            en: "We introduce our team through roles, backgrounds, and project records\u2014so you can see how each role contributes on real engagements."
        }
    },
    overviewLabel: {
        ja: "\u30E1\u30F3\u30D0\u30FC\u4E00\u89A7",
        en: "Members"
    },
    detailLabel: {
        ja: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
        en: "Profile"
    },
    bioLabel: {
        ja: "\u7565\u6B74",
        en: "Background"
    },
    projectsLabel: {
        ja: "\u4E3B\u8981\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30FB\u8077\u52D9\u7D4C\u6B74",
        en: "Projects & experience"
    },
    table: {
        role: {
            ja: "\u5F79\u5272",
            en: "Role"
        },
        client: {
            ja: "\u304A\u5BA2\u69D8",
            en: "Client"
        },
        theme: {
            ja: "\u3054\u652F\u63F4\u30C6\u30FC\u30DE",
            en: "Engagement"
        },
        detail: {
            ja: "\u5BFE\u5FDC\u5185\u5BB9",
            en: "Scope"
        }
    },
    members: [
        {
            id: "riku",
            image: "team-riku.png",
            role: {
                ja: "\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30C6\u30A3\u30B9\u30C8 / \u30A8\u30F3\u30B8\u30CB\u30A2",
                en: "Data scientist & engineer"
            },
            name: {
                ja: "\u9577\u91CE \u9678",
                en: "Riku Nagano"
            },
            reading: {
                ja: "\u306A\u304C\u306E \u308A\u304F",
                en: "Riku Nagano"
            },
            age: {
                ja: "28\u6B73",
                en: "28"
            },
            tags: {
                ja: [
                    "\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30C6\u30A3\u30B9\u30C8",
                    "\u30A8\u30F3\u30B8\u30CB\u30A2",
                    "\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8",
                    "\u30EA\u30B5\u30FC\u30C1\u30E3\u30FC"
                ],
                en: [
                    "Data scientist",
                    "Engineer",
                    "Consultant",
                    "Researcher"
                ]
            },
            bio: {
                ja: [
                    "\u5927\u5B66\u3092\u4E3B\u5E2D\u304B\u3064\u98DB\u3073\u7D1A\u3067\u5352\u696D\u3057\u3001AI\u30FBIT\u306E\u5C02\u9580\u6027\u3092\u6DF1\u3081\u308B\u305F\u3081\u5927\u5B66\u9662\u3067\u7814\u7A76",
                    "\u5927\u624B\u306EIT\u30FB\u901A\u4FE1\u4F01\u696D\u30B0\u30EB\u30FC\u30D7\u306B\u3066\u3001\u7D4C\u55B6\u30C8\u30C3\u30D7\u76F4\u4E0B\u3067\u6210\u9577\u6226\u7565\u306E\u30C7\u30FC\u30BF\u5206\u6790\u30FB\u4E8B\u696D\u6226\u7565\u3092\u62C5\u5F53",
                    "\u5927\u624B\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30D5\u30A1\u30FC\u30E0\u306B\u3066\u3001AI\u30FB\u5148\u7AEF\u6280\u8853\u9818\u57DF\u306E\u4E8B\u696D\u6226\u7565\u7ACB\u6848\u3092\u30EA\u30FC\u30C9",
                    "\u591A\u696D\u7A2E\u306E\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u30FB\u8981\u4EF6\u6574\u7406\u30FB\u4E8B\u696D\u958B\u767A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u5E45\u5E83\u304F\u53C2\u753B",
                    "\u7D4C\u6E08\u7523\u696D\u7701\u306E\u9AD8\u5EA6IT\u4EBA\u6750\u3068\u3057\u3066\u3001\u5730\u65B9\u81EA\u6CBB\u4F53\u9023\u643A\u306E\u5730\u57DFDX\u63A8\u9032\u3092\u62C5\u5F53",
                    "\u6B21\u4E16\u4EE3\u7D4C\u55B6\u4EBA\u6750\u80B2\u6210\u30D7\u30ED\u30B0\u30E9\u30E0\u3001\u56FD\u306EAI\u30FB\u30B5\u30A4\u30D0\u30FC\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4EBA\u6750\u80B2\u6210\u4E8B\u696D\u306B\u9078\u51FA\u30FB\u53C2\u753B"
                ],
                en: [
                    "Graduated top of class with accelerated completion; pursued grad school to deepen AI & IT expertise",
                    "At a major IT and telecom group\u2014data analysis and growth strategy under top executive leadership",
                    "At a leading consulting firm\u2014led business strategy for AI and emerging technology domains",
                    "Broad engagements across systems development, requirements, and business development across industries",
                    "METI advanced IT talent\u2014regional DX programs in partnership with local government",
                    "Selected for executive development and national AI / cybersecurity talent programs"
                ]
            },
            projects: [
                {
                    category: {
                        ja: "AI",
                        en: "AI"
                    },
                    client: {
                        ja: "\u6CD5\u4EBA\u5411\u3051",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "\u696D\u52D9\u52B9\u7387\u5316\u652F\u63F4\u30C4\u30FC\u30EB\u306E\u5C0E\u5165",
                        en: "Workflow efficiency tooling"
                    },
                    role: {
                        ja: "\u6226\u7565\u30FB\u8A2D\u8A08",
                        en: "Strategy & design"
                    },
                    detail: {
                        ja: "\u696D\u52D9\u30D5\u30ED\u30FC\u6574\u7406\u3001\u696D\u52D9\u52B9\u7387\u5316\u63D0\u6848",
                        en: "Process mapping and efficiency proposals"
                    }
                },
                {
                    category: {
                        ja: "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2",
                        en: "Software"
                    },
                    client: {
                        ja: "\u6CD5\u4EBA\u5411\u3051",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "Web\u30AF\u30ED\u30FC\u30E9\u30B7\u30B9\u30C6\u30E0\u306E\u5C0E\u5165",
                        en: "Web crawler rollout"
                    },
                    role: {
                        ja: "\u8A2D\u8A08",
                        en: "Design"
                    },
                    detail: {
                        ja: "\u30C7\u30FC\u30BF\u4FDD\u5B58\u301C\u5229\u6D3B\u7528\u307E\u3067\u306E\u30D5\u30ED\u30FC\u306E\u6574\u7406\u3092\u652F\u63F4",
                        en: "End-to-end data capture and utilization flows"
                    }
                },
                {
                    category: {
                        ja: "\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2",
                        en: "Hardware"
                    },
                    client: {
                        ja: "\u6CD5\u4EBA\u5411\u3051",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "AR/VR/MR\u3092\u7528\u3044\u305F\u4EEE\u60F3\u7A7A\u9593\u3067\u306E\u5B9F\u5730\u691C\u8A3C",
                        en: "AR/VR/MR field validation"
                    },
                    role: {
                        ja: "\u8981\u4EF6\u6574\u7406",
                        en: "Requirements"
                    },
                    detail: {
                        ja: "\u30B7\u30B9\u30C6\u30E0\u8981\u4EF6\u6574\u7406\u3001\u5C0E\u5165\u307E\u3067\u306E\u30D7\u30ED\u30BB\u30B9\u63D0\u6848",
                        en: "Requirements through adoption roadmap"
                    }
                },
                {
                    category: {
                        ja: "AI",
                        en: "AI"
                    },
                    client: {
                        ja: "\u591A\u696D\u7A2E",
                        en: "Multi-industry"
                    },
                    theme: {
                        ja: "\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u5206\u6790\u30FBAI\u4E88\u6E2C\u30E2\u30C7\u30EB\u30FBR&D",
                        en: "Big data, forecasting, R&D"
                    },
                    role: {
                        ja: "\u5B9F\u88C5",
                        en: "Build"
                    },
                    detail: {
                        ja: "NLP\u3001\u753B\u50CF\u691C\u51FA/\u8A8D\u8B58\u3001\u9700\u8981\u4E88\u6E2C\u3001\u97F3\u58F0\u8A8D\u8B58/\u5408\u6210",
                        en: "NLP, vision, demand forecasting, speech"
                    }
                },
                {
                    category: {
                        ja: "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2",
                        en: "Software"
                    },
                    client: {
                        ja: "\u6570\u5341\u793E\u4EE5\u4E0A",
                        en: "30+ companies"
                    },
                    theme: {
                        ja: "Web/\u30E2\u30D0\u30A4\u30EB\u30FBAPI\u30FB\u30A4\u30F3\u30D5\u30E9",
                        en: "Web/mobile, API, infra"
                    },
                    role: {
                        ja: "\u4E00\u6C17\u901A\u8CAB",
                        en: "End-to-end"
                    },
                    detail: {
                        ja: "\u7B2C1\u301C3\u6B21\u7523\u696D\u307E\u3067\u5E45\u5E83\u3044\u30B7\u30B9\u30C6\u30E0\u63D0\u4F9B\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8106\u5F31\u6027\u8A3A\u65AD",
                        en: "Cross-industry delivery and security assessment"
                    }
                },
                {
                    category: {
                        ja: "\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2",
                        en: "Hardware"
                    },
                    client: {
                        ja: "\u81EA\u793E/\u6CD5\u4EBA",
                        en: "In-house & clients"
                    },
                    theme: {
                        ja: "\u81EA\u7ACB\u578B\u30C9\u30ED\u30FC\u30F3\u30FB\u690D\u7269\u5DE5\u5834",
                        en: "Autonomous drones & plant factories"
                    },
                    role: {
                        ja: "\u958B\u767A",
                        en: "Engineering"
                    },
                    detail: {
                        ja: "\u30BB\u30F3\u30B5\u30FC\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u5236\u5FA1\u3001\u56DE\u8DEF\u8A2D\u8A08\u30FB\u69CB\u7BC9",
                        en: "Sensor feedback control and circuit design"
                    }
                }
            ]
        },
        {
            id: "hirata",
            image: "team-hirata.png",
            role: {
                ja: "\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8 / PM",
                en: "Consultant & PM"
            },
            name: {
                ja: "\u5E73\u7530 \u5927\u7A7A",
                en: "Hirotaka Hirata"
            },
            reading: {
                ja: "\u3072\u3089\u305F \u3072\u308D\u305F\u304B",
                en: "Hirotaka Hirata"
            },
            age: {
                ja: "29\u6B73",
                en: "29"
            },
            tags: {
                ja: [
                    "IT\u6226\u7565",
                    "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u57FA\u76E4",
                    "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3",
                    "PM"
                ],
                en: [
                    "IT strategy",
                    "Network architecture",
                    "Security",
                    "PM"
                ]
            },
            bio: {
                ja: [
                    "\u65B0\u5352\u3067\u30BD\u30D5\u30C8\u30D0\u30F3\u30AF\u3078\u5165\u793E\u5F8C\u3001IT\u69CB\u60F3\u7B56\u5B9A\u3084\u30ED\u30FC\u30C9\u30DE\u30C3\u30D7\u7B56\u5B9A\u306A\u3069\u5E45\u5E83\u3044\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u306B\u5F93\u4E8B",
                    "\u305D\u306E\u5F8C\u30B9\u30BF\u30FC\u30C8\u30A2\u30C3\u30D7\u3067\u53D6\u7DE0\u5F79\u306B\u5C31\u4EFB\u3057\u3001\u58F2\u4E0A\u524D\u671F\u6BD45\u500D\u6210\u9577\u306B\u8CA2\u732E",
                    "\u4FDD\u6709\u8CC7\u683C\uFF1ACompTIA Project+\u3001CompTIA Cloud+\u3001Professional Google Workspace Administrator \u7B49"
                ],
                en: [
                    "Joined SoftBank as new grad\u2014IT visioning, roadmaps, and consulting programs",
                    "Later joined a startup as director; helped drive 5\xd7 YoY revenue growth",
                    "CompTIA Project+, CompTIA Cloud+, Professional Google Workspace Administrator, and more"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u81EA\u52D5\u8ECA\u696D\u754C",
                        en: "Automotive"
                    },
                    theme: {
                        ja: "\u4E2D\u671F\u4E8B\u696D\u8A08\u753B\u7B56\u5B9A",
                        en: "Mid-term business plan"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u696D\u754C\u5171\u901ANW\u57FA\u76E4\u3068\u3057\u3066\u30C7\u30FC\u30BF\u4E3B\u6A29\u3092\u91CD\u3093\u3058\u305F\u3042\u308B\u3079\u304D\u59FF\u3068\u5B9F\u884C\u8A08\u753B\u3092\u7B56\u5B9A",
                        en: "Target-state and execution plan for a data-sovereign industry network"
                    }
                },
                {
                    client: {
                        ja: "\u30A8\u30F3\u30BF\u30E1\u5927\u624B",
                        en: "Entertainment"
                    },
                    theme: {
                        ja: "\u6B21\u671FNW\u57FA\u76E4\u69CB\u60F3RFP",
                        en: "Next-gen network RFP"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u30E6\u30FC\u30B6\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306ANW\u74B0\u5883\u3092\u30C6\u30FC\u30DE\u306BRFP\u3092\u4F5C\u6210\u3057\u3001\u7AF6\u54084\u793E\u4E2D\u6700\u9AD8\u70B9\u3067\u53D7\u6CE8",
                        en: "User-friendly network RFP; top score among four vendors and won the deal"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u57FA\u5E79\u30B7\u30B9\u30C6\u30E0\u696D\u52D9\u30D2\u30A2\u30EA\u30F3\u30B0",
                        en: "ERP field discovery"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u4E3B\u8981\u62E0\u70B9\u3092\u8A2A\u554F\u3057\u3066\u751F\u306E\u58F0\u3092\u96C6\u7D04\u3057\u3001\u7B2C\u4E09\u8005\u8996\u70B9\u3067\u30B0\u30E9\u30F3\u30C9\u30C7\u30B6\u30A4\u30F3\u3092\u63D0\u8A00",
                        en: "Multi-site interviews and third-party grand-design recommendations"
                    }
                },
                {
                    client: {
                        ja: "\u4EBA\u6750\u696D\u754C",
                        en: "HR tech"
                    },
                    theme: {
                        ja: "\u4EBA\u6750\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u958B\u767A",
                        en: "Talent platform"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u30AA\u30D5\u30B7\u30E7\u30A2\u9023\u643A\u3067AI\u6A5F\u80FD\u5B9F\u88C5\u30FB\u30A4\u30F3\u30D5\u30E9\u6539\u4FEE\u30FB\u904B\u7528\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0",
                        en: "Offshore-led AI features, infra fixes, and ops troubleshooting"
                    }
                },
                {
                    client: {
                        ja: "\u30A8\u30F3\u30BF\u30E1\u696D\u754C",
                        en: "Entertainment"
                    },
                    theme: {
                        ja: "\u691C\u7D22\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u958B\u767A",
                        en: "Search platform"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "\u30A4\u30F3\u30D0\u30A6\u30F3\u30C9\u8981\u7D20\u3068AI\u8981\u7D20\u3092\u304F\u307F\u53D6\u308A\u3001\u8A2D\u8A08\u30D5\u30A7\u30FC\u30BA\u3078\u306E\u6A4B\u6E21\u3057\u3092\u5B9F\u65BD",
                        en: "Bridged inbound and AI requirements into the design phase"
                    }
                },
                {
                    client: {
                        ja: "\u30A2\u30D1\u30EC\u30EB\u696D\u754C",
                        en: "Apparel"
                    },
                    theme: {
                        ja: "\u30B7\u30B9\u30C6\u30E0\u9023\u643AAPI\u958B\u767A",
                        en: "Integration API"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "Channel talk\u3068Salesforce\u3092\u9023\u643A\u3059\u308B\u72EC\u81EAAPI\u3092\u958B\u767A",
                        en: "Custom API linking Channel talk and Salesforce"
                    }
                },
                {
                    client: {
                        ja: "\u98DF\u54C1\u88FD\u9020\u696D",
                        en: "Food manufacturing"
                    },
                    theme: {
                        ja: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30ED\u30FC\u30C9\u30DE\u30C3\u30D7\u7B56\u5B9A",
                        en: "Security roadmap"
                    },
                    role: {
                        ja: "\u30E1\u30F3\u30D0\u30FC",
                        en: "Member"
                    },
                    detail: {
                        ja: "NIST CSF\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u767D\u66F8\u7B49\u3092\u7528\u3044\u305F\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B0\u30E9\u30F3\u30C9\u30C7\u30B6\u30A4\u30F3\u3092\u63CF\u51FA",
                        en: "Security grand design using NIST CSF and JP frameworks"
                    }
                }
            ]
        },
        {
            id: "aimoto",
            image: "team-aimoto.png",
            role: {
                ja: "\u30C6\u30C3\u30AF\u30EA\u30FC\u30C9 / \u30A8\u30F3\u30B8\u30CB\u30A2",
                en: "Tech lead & engineer"
            },
            name: {
                ja: "\u76F8\u672C \u5065",
                en: "Takeshi Aimoto"
            },
            reading: {
                ja: "\u3042\u3044\u3082\u3068 \u305F\u3051\u3057",
                en: "Takeshi Aimoto"
            },
            age: {
                ja: "29\u6B73",
                en: "29"
            },
            tags: {
                ja: [
                    "Power Platform",
                    "xR / AR",
                    "\u751F\u6210AI",
                    "RAG"
                ],
                en: [
                    "Power Platform",
                    "xR / AR",
                    "GenAI",
                    "RAG"
                ]
            },
            bio: {
                ja: [
                    "\u65B0\u5352\u3067\u4E09\u83F1\u96FB\u6A5F\u7CFB\u5217\u306EIT\u30D9\u30F3\u30C0\u30FC\u3078\u5165\u793E\u3002\u8981\u4EF6\u5B9A\u7FA9\u304B\u3089\u958B\u767A\u30FB\u904B\u7528\u307E\u3067\u7D4C\u9A13",
                    "AI\u3001xR\u3001\u30E1\u30BF\u30D0\u30FC\u30B9\u306A\u3069\u306E\u5148\u7AEF\u6280\u8853\u958B\u767A\u306B\u3082\u643A\u308F\u308B",
                    "\u30B9\u30BF\u30FC\u30C8\u30A2\u30C3\u30D7\u3067\u30DE\u30CD\u30FC\u30B8\u30E3\u30FC\u3068\u3057\u3066\u6848\u4EF6\u9042\u884C\u3068\u30C7\u30A3\u30EC\u30AF\u30B7\u30E7\u30F3",
                    "\u4FDD\u6709\u8CC7\u683C\uFF1APower Platform Fundamentals"
                ],
                en: [
                    "Joined Mitsubishi Electric\u2013group IT vendor; requirements through ops",
                    "Advanced work in AI, xR, and metaverse",
                    "Startup manager\u2014delivery and technical direction",
                    "Power Platform Fundamentals certified"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u696D\u52D9\u6539\u9769\u652F\u63F4\uFF08Power Platform\uFF09",
                        en: "Power Platform modernization"
                    },
                    role: {
                        ja: "PM / PMO",
                        en: "PM / PMO"
                    },
                    detail: {
                        ja: "\u63D0\u6848\u304B\u3089PoC\u3001\u8A2D\u8A08\u3001\u958B\u767A\u3001\u30C6\u30B9\u30C8\u3001\u5C0E\u5165\u307E\u3067\u5B9F\u65BD",
                        en: "Proposal through PoC, build, test, and rollout"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "xR\u30B7\u30B9\u30C6\u30E0\u958B\u767A",
                        en: "xR systems"
                    },
                    role: {
                        ja: "PM / \u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "PM / engineer"
                    },
                    detail: {
                        ja: "AR/MR\u696D\u52D9\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u3068\u7279\u8A31\u51FA\u9858",
                        en: "AR/MR ops systems and patent filing"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u6570\u7406\u6700\u9069\u5316AI",
                        en: "Optimization AI"
                    },
                    role: {
                        ja: "PM / \u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "PM / engineer"
                    },
                    detail: {
                        ja: "\u6570\u7406\u6700\u9069\u5316\u30E2\u30C7\u30EB\u3092\u6D3B\u7528\u3057\u305FWeb\u30B7\u30B9\u30C6\u30E0",
                        en: "Web app powered by optimization models"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u30E1\u30BF\u30D0\u30FC\u30B9\u958B\u767A",
                        en: "Metaverse"
                    },
                    role: {
                        ja: "PM / \u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "PM / engineer"
                    },
                    detail: {
                        ja: "\u30E1\u30BF\u30D0\u30FC\u30B9\u958B\u767A\u3068ChatGPT\u30C1\u30E3\u30C3\u30C8\u30DC\u30C3\u30C8\u5C0E\u5165",
                        en: "Metaverse build plus ChatGPT bot"
                    }
                },
                {
                    client: {
                        ja: "\u30A8\u30F3\u30BF\u30E1\u696D\u754C",
                        en: "Entertainment"
                    },
                    theme: {
                        ja: "\u691C\u7D22\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u958B\u767A",
                        en: "Search platform"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u30A4\u30F3\u30D0\u30A6\u30F3\u30C9\xd7AI\u306E\u8981\u4EF6\u5B9A\u7FA9\u30FB\u8A2D\u8A08\u30FBAI\u6A5F\u80FDPoC",
                        en: "Inbound \xd7 AI requirements, design, and AI PoC"
                    }
                },
                {
                    client: {
                        ja: "\u30A2\u30D1\u30EC\u30EB\u696D\u754C",
                        en: "Apparel"
                    },
                    theme: {
                        ja: "\u30B7\u30B9\u30C6\u30E0\u9023\u643AAPI\u958B\u767A",
                        en: "Integration API"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "Channel talk\u3068Salesforce\u3092\u9023\u643A\u3059\u308B\u72EC\u81EAAPI\u3092\u958B\u767A",
                        en: "Custom API linking Channel talk and Salesforce"
                    }
                },
                {
                    client: {
                        ja: "\u5EFA\u7BC9\u696D\u754C",
                        en: "Construction"
                    },
                    theme: {
                        ja: "\u30EA\u30B9\u30AD\u30EA\u30F3\u30B0AI\u30C4\u30FC\u30EB",
                        en: "Reskilling AI tool"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "GPTs\u3067\u55B6\u696D\u30C8\u30FC\u30AF\u30B7\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u767A",
                        en: "GPTs sales-talk simulation"
                    }
                },
                {
                    client: {
                        ja: "\u4EBA\u6750\u696D\u754C",
                        en: "HR tech"
                    },
                    theme: {
                        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8\u6539\u4FEE",
                        en: "Product enhancement"
                    },
                    role: {
                        ja: "TL",
                        en: "TL"
                    },
                    detail: {
                        ja: "\u30AA\u30D5\u30B7\u30E7\u30A2\u9023\u643A\u3067\u6A5F\u80FD\u6539\u4FEE\u30FBAI\u5B9F\u88C5\u30FB\u30A4\u30F3\u30D5\u30E9\u6539\u4FEE\u30FB\u904B\u7528TS",
                        en: "Offshore-led feature, AI, infra, and ops fixes"
                    }
                },
                {
                    client: {
                        ja: "IT\u696D\u754C",
                        en: "IT"
                    },
                    theme: {
                        ja: "\u52D5\u753B\u5224\u5B9AAI",
                        en: "Video moderation AI"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "\u751F\u6210AI\u30E2\u30C7\u30EB\u3092\u6D3B\u7528\u3057\u305F\u5371\u967A\u52D5\u753B\u5224\u5B9AAPI\u3092\u958B\u767A",
                        en: "Hazard video detection API with generative models"
                    }
                },
                {
                    client: {
                        ja: "IT\u696D\u754C",
                        en: "IT"
                    },
                    theme: {
                        ja: "PowerPoint\u4F5C\u6210AI Agent",
                        en: "PowerPoint AI agent"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "\u5BA2\u5148\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u306B\u5408\u308F\u305B\u305FPowerPoint\u51FA\u529BAgent\u3092\u958B\u767A",
                        en: "Client-format PowerPoint output agent"
                    }
                },
                {
                    client: {
                        ja: "\u91D1\u878D\u696D\u754C",
                        en: "Finance"
                    },
                    theme: {
                        ja: "\u627F\u8A8D\u30B7\u30B9\u30C6\u30E0\u958B\u767A",
                        en: "Approval system"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "Power Platform\u3092\u6D3B\u7528\u3057\u305F\u627F\u8A8D\u30B7\u30B9\u30C6\u30E0\u3092\u958B\u767A",
                        en: "Approval workflow built on Power Platform"
                    }
                },
                {
                    client: {
                        ja: "IT\u696D\u754C",
                        en: "IT"
                    },
                    theme: {
                        ja: "\u793E\u5185\u6587\u66F8RAG\u30B7\u30B9\u30C6\u30E0",
                        en: "Internal document RAG"
                    },
                    role: {
                        ja: "\u30B3\u30F3\u30B5\u30EB / \u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Consulting / engineer"
                    },
                    detail: {
                        ja: "AWS\u4E0A\u306B\u793E\u5185\u6587\u66F8\u3092\u767B\u9332\u3057\u305FRAG\u30B7\u30B9\u30C6\u30E0\u306E\u7B56\u5B9A\u3068\u958B\u767A",
                        en: "Designed and built an AWS-hosted internal document RAG system"
                    }
                }
            ]
        },
        {
            id: "nakano",
            image: "team-nakano.png",
            role: {
                ja: "PM / PMO",
                en: "PM / PMO"
            },
            name: {
                ja: "\u4E2D\u91CE \u4E8C\u4E09\u7AE0",
                en: "Fumiyuki Nakano"
            },
            reading: {
                ja: "\u306A\u304B\u306E \u3075\u307F\u3086\u304D",
                en: "Fumiyuki Nakano"
            },
            age: {
                ja: "29\u6B73",
                en: "29"
            },
            tags: {
                ja: [
                    "\u5927\u898F\u6A21\u30B7\u30B9\u30C6\u30E0\u5C0E\u5165",
                    "\u901A\u4FE1\u30A4\u30F3\u30D5\u30E9",
                    "\u7D44\u7E54\u30DE\u30CD\u30B8\u30E1\u30F3\u30C8",
                    "\u696D\u52D9\u30D5\u30ED\u30FC\u8A2D\u8A08"
                ],
                en: [
                    "Large-scale rollout",
                    "Telecom infra",
                    "Org leadership",
                    "Process design"
                ]
            },
            bio: {
                ja: [
                    "\u697D\u5929\u30E2\u30D0\u30A4\u30EB\u306B\u3066\u57FA\u5730\u5C40\u8A2D\u7F6E\u55B6\u696D\u3092\u7D4C\u9A13\u5F8C\u3001\u57FA\u5730\u5C40\u8A2D\u8A08\u30FB\u5DE5\u4E8B\u898B\u7A4D\u7CBE\u67FB\u30FB\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u7D71\u62EC\u306B\u5F93\u4E8B",
                    "\u7D0440\u540D\u898F\u6A21\u306E\u8A2D\u8A08\u7BA1\u7406\u30B0\u30EB\u30FC\u30D7VGM\u3068\u3057\u3066\u3001\u672C\u793E\u5EFA\u8A2D\u90E8\u3068\u306E\u6298\u885D\u30FB\u65B9\u91DD\u6C7A\u5B9A\u3092\u62C5\u5F53",
                    "\u6CD5\u4EBA\u4E8B\u696D\u672C\u90E8\u3067\u30B7\u30B9\u30C6\u30E0\u5C0E\u5165PJT\u306EPM/PMO\u3092\u8907\u6570\u62C5\u5F53",
                    "\u8ACB\u6C42\u66F8\u767A\u884C\u30B7\u30B9\u30C6\u30E0\u30922\u30F6\u6708\u5F37\u3067\u9078\u5B9A\u301C\u672C\u756A\u904B\u7528\u958B\u59CB\u307E\u3067\u5B8C\u9042"
                ],
                en: [
                    "Rakuten Mobile\u2014site sales, then design, estimate review, and document governance",
                    "VGM for ~40-person design org; regional lead vs. HQ construction",
                    "Multiple system rollout PM/PMO programs in enterprise division",
                    "Billing system live in ~2 months from selection"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u57FA\u5730\u5C40\u8A2D\u7F6E\u55B6\u696D",
                        en: "Site acquisition sales"
                    },
                    role: {
                        ja: "\u55B6\u696D",
                        en: "Sales"
                    },
                    detail: {
                        ja: "23\u5C40\u306E\u8A2D\u7F6E\u5408\u610F\u3002\u5DE5\u4E8B\u4E2D\u6B62\u738710%\uFF08\u55B6\u696D30\u540D\u4E2D2\u4F4D\uFF09",
                        en: "23 site agreements; 10% cancel rate (#2 of 30)"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u5DE5\u4E8B\u898B\u7A4D\u7CBE\u67FB\uFF0F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u7BA1\u7406",
                        en: "Estimate & document control"
                    },
                    role: {
                        ja: "\u30EA\u30FC\u30C0\u30FC",
                        en: "Lead"
                    },
                    detail: {
                        ja: "206\u5C40\u627F\u8A8D\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30C1\u30FC\u30E0\u7D71\u62EC\uFF08\u7D0410\u540D\uFF09",
                        en: "206 approvals; ~10-person doc team lead"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u90E8\u6750\u30FB\u6210\u679C\u7269\u63D0\u51FA\u7BA1\u7406",
                        en: "Materials & deliverables"
                    },
                    role: {
                        ja: "\u7D71\u62EC\u88DC\u4F50",
                        en: "Deputy lead"
                    },
                    detail: {
                        ja: "\u5B8C\u6210\u56F3\u66F8\u63D0\u51FA\u4FC3\u9032\u4F53\u5236\u3092\u69CB\u7BC9\u3002KPI\u9054\u6210\u7387100%\u8D85\uFF08\u6700\u5927489%\uFF09",
                        en: "As-built submission framework; KPI over 100% (peak 489%)"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u8A2D\u8A08\u7BA1\u7406\uFF0F\u5730\u57DF\u4EE3\u8868",
                        en: "Design management"
                    },
                    role: {
                        ja: "VGM",
                        en: "VGM"
                    },
                    detail: {
                        ja: "\u7D0440\u540D\u7D71\u62EC\u3001\u672C\u793E\u6298\u885D\u30FB\u5730\u57DF\u65B9\u91DD\u6C7A\u5B9A\u3002\u56F3\u9762\u4FEE\u6B63\u8CBB\u6291\u5236\uFF08221\u5C40\uFF0B202\u5C40\u5F71\u97FF\uFF09",
                        en: "~40 FTE org; drawing cost control across 221+202 sites"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u5927\u898F\u6A21\u8A2D\u8A08\u65B9\u91DD\u5909\u66F4\u5BFE\u5FDC",
                        en: "Major design-policy change"
                    },
                    role: {
                        ja: "\u610F\u601D\u6C7A\u5B9A",
                        en: "Decision lead"
                    },
                    detail: {
                        ja: "5G\u56F3\u9762\u63D0\u51FA\u306E\u4E00\u6642\u505C\u6B62\u5224\u65AD\u306A\u3069\u3001\u4FEE\u6B63\u8CBB\u30FB\u5DE5\u6570\u524A\u6E1B\u3092\u4E3B\u5C0E",
                        en: "Paused 5G drawing submissions to cut rework cost and effort"
                    }
                },
                {
                    client: {
                        ja: "\u6CD5\u4EBA\u4E8B\u696D",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "\u8ACB\u6C42\u66F8\u767A\u884C\u30B7\u30B9\u30C6\u30E0\u5C0E\u5165",
                        en: "Billing system rollout"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "\u9078\u5B9A\u301C\u672C\u756A\u904B\u7528\u307E\u30672\u30F6\u6708\u5F37\u3067\u5B8C\u9042\u3002\u793E\u5185\u5916\u8ABF\u6574\u30FB\u5951\u7D04\u30FB\u696D\u52D9\u30D5\u30ED\u30FC\u6574\u7406",
                        en: "Selection to production in ~2 months; contracts and process design"
                    }
                },
                {
                    client: {
                        ja: "\u6CD5\u4EBA\u4E8B\u696D",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "\u8CA9\u58F2\u7BA1\u7406\u30B7\u30B9\u30C6\u30E0\u5C0E\u5165",
                        en: "Sales ops system"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u30D5\u30ED\u30FC\u6574\u7406\u30FB\u30E6\u30FC\u30B6\u30FC\u30C6\u30B9\u30C8\u8ABF\u6574\u30FB\u8907\u6570PJT\u4E26\u884C\u7BA1\u7406",
                        en: "Process design, UAT coordination, and multi-project delivery"
                    }
                },
                {
                    client: {
                        ja: "\u6CD5\u4EBA\u4E8B\u696D",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "\u696D\u52D9\u30D5\u30ED\u30FC\u69CB\u7BC9",
                        en: "Process design"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u30A4\u30F3\u30DC\u30A4\u30B9\u5236\u5EA6\u5BFE\u5FDC\u3001\u4EE3\u7406\u5E97\u623B\u5165\u91D1\u56DE\u53CE\u30D5\u30ED\u30FC\u3092\u69CB\u7BC9",
                        en: "Invoice-regime and agency rebate recovery flows"
                    }
                },
                {
                    client: {
                        ja: "\u6CD5\u4EBA\u4E8B\u696D",
                        en: "Enterprise"
                    },
                    theme: {
                        ja: "\u7D44\u7E54\u30FB\u4EBA\u6750\u80B2\u6210",
                        en: "Org & talent development"
                    },
                    role: {
                        ja: "\u30DE\u30CD\u30B8\u30E3\u30FC",
                        en: "Manager"
                    },
                    detail: {
                        ja: "\u65B0\u5352\u80B2\u6210\u3001\u7D44\u7E54\u4F53\u5236\u518D\u8A2D\u8A08\u3001\u5F15\u7D99\u304E\u8A2D\u8A08\u3092\u63A8\u9032",
                        en: "New-grad coaching, org redesign, and handoff design"
                    }
                }
            ]
        },
        {
            id: "kodaka",
            image: "team-kodaka.png",
            role: {
                ja: "\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8 / PM",
                en: "Consultant & PM"
            },
            name: {
                ja: "\u5C0F\u9AD8 \u5065\u4EBA",
                en: "Kento Kodaka"
            },
            reading: {
                ja: "\u3053\u3060\u304B \u3051\u3093\u3068",
                en: "Kento Kodaka"
            },
            age: {
                ja: "29\u6B73",
                en: "29"
            },
            tags: {
                ja: [
                    "\u9032\u6357\u7BA1\u7406",
                    "\u30B9\u30AF\u30E9\u30E0",
                    "\u30C7\u30FC\u30BF\u6D3B\u7528",
                    "\u30D9\u30F3\u30C0\u30FC\u7BA1\u7406"
                ],
                en: [
                    "Delivery mgmt",
                    "Scrum",
                    "Data enablement",
                    "Vendor mgmt"
                ]
            },
            bio: {
                ja: [
                    "\u697D\u5929\u30E2\u30D0\u30A4\u30EB\u306B\u3066\u3001\u57FA\u5730\u5C40\u8A2D\u7F6E\u306E\u9032\u6357\u7BA1\u7406\u30FB\u30C7\u30FC\u30BF\u7BA1\u7406\u30B0\u30EB\u30FC\u30D7\u7ACB\u3061\u4E0A\u3052\u3092\u30EA\u30FC\u30C0\u30FC\u3068\u3057\u3066\u7D4C\u9A13",
                    "\u30D9\u30A4\u30AB\u30EC\u30F3\u30C8\u3067\u306F\u696D\u52D9\u6574\u7406\u30FBToBe\u8A2D\u8A08\u306B\u52A0\u3048\u3001\u81EA\u3089\u30D7\u30ED\u30C8\uFF0F\u30B7\u30B9\u30C6\u30E0\u3092\u4F5C\u308A\u306A\u304C\u3089\u5B9F\u88C5\u5BC4\u308A\u3067\u63A8\u9032",
                    "\u30AA\u30D5\u30B7\u30E7\u30A2\u958B\u767A\u30DE\u30CD\u30B8\u30E1\u30F3\u30C8\u3082\u7D4C\u9A13\u3057\u3001\u8981\u4EF6\u301C\u8A2D\u8A08\u301C\u5B9F\u88C5\u301C\u904B\u7528\u3092\u4E00\u6C17\u901A\u8CAB\u3067\u56DE\u3057\u305F\u7D4C\u9A13\u3042\u308A",
                    "\u30D3\u30B8\u30CD\u30B9\u5074\u3068\u30B7\u30B9\u30C6\u30E0\u5074\u306E\u4E21\u65B9\u306E\u77E5\u898B\u3092\u6D3B\u304B\u3057\u3001\u81EA\u8D70\u3057\u3064\u3064\u6A4B\u6E21\u3057\u3092\u3059\u308B"
                ],
                en: [
                    "Rakuten Mobile\u2014led site-build progress control and a new data-management group",
                    "BayCurrent: ToBe design plus hands-on prototyping to keep programs moving",
                    "Offshore program management from requirements through ops",
                    "Bridges business and engineering while driving delivery independently"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D\u754C",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u57FA\u5730\u5C40\u8A2D\u7F6E\u9032\u6357\u7BA1\u7406\uFF0F\u30C7\u30FC\u30BF\u7BA1\u7406G\u7ACB\u4E0A\u3052",
                        en: "Site-build progress & data org"
                    },
                    role: {
                        ja: "\u30E1\u30F3\u30D0\u30FC / \u30EA\u30FC\u30C0\u30FC",
                        en: "Member / lead"
                    },
                    detail: {
                        ja: "\u4E2D\u56DB\u56FD\u30A8\u30EA\u30A2\u306E\u9032\u6357\u7BA1\u7406\u301C5G\u8A2D\u7F6E\u7D71\u62EC\u3002\u6A2A\u65AD\u30C7\u30FC\u30BF\u7BA1\u7406G\u3092\u7ACB\u4E0A\u3052\u3001\u5E74\u9593MVP\u53D7\u8CDE",
                        en: "Chugoku-Shikoku progress and 5G lead; founded cross-org data group; annual MVP"
                    }
                },
                {
                    client: {
                        ja: "\u81EA\u52D5\u8ECA\u696D\u754C",
                        en: "Automotive"
                    },
                    theme: {
                        ja: "\u6B21\u4E16\u4EE3\u30AB\u30FC\u30CA\u30D3\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u652F\u63F4",
                        en: "Next-gen car navigation"
                    },
                    role: {
                        ja: "\u30B9\u30AF\u30E9\u30E0\u30DE\u30B9\u30BF\u30FC",
                        en: "Scrum master"
                    },
                    detail: {
                        ja: "\u6D77\u5916\u30D9\u30F3\u30C0\u30FC2\u793E\u7BA1\u7406\u3001\u82F1\u8A9E\u4F1A\u8B70\u9032\u884C\u3001JIRA\u4E00\u5143\u5316\u3002\u97D3\u56FD\u51FA\u5F353\u5EA6\u5E2F\u540C",
                        en: "Managed 2 overseas vendors, English facilitation, JIRA; 3 Korea trips"
                    }
                },
                {
                    client: {
                        ja: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u696D\u754C",
                        en: "Credit cards"
                    },
                    theme: {
                        ja: "SAS\u30D7\u30ED\u30B0\u30E9\u30E0\u6539\u4FEE",
                        en: "SAS program changes"
                    },
                    role: {
                        ja: "\u30C7\u30FC\u30BF\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Data engineer"
                    },
                    detail: {
                        ja: "\u5546\u54C1\u6027\u6539\u5B9A\u306B\u4F34\u3046\u6539\u4FEE\u8981\u5426\u5224\u5B9A\u301C\u6539\u4FEE\u30FB\u30C6\u30B9\u30C8\u3002\u672C\u90E8\u9577\u5411\u3051\u6708\u6B21\u5831\u544A\u8CC7\u6599\u3092\u4F5C\u6210",
                        en: "Change impact, SAS build/test, and monthly exec reporting"
                    }
                },
                {
                    client: {
                        ja: "\u96FB\u529B\u696D\u754C",
                        en: "Energy"
                    },
                    theme: {
                        ja: "SaaS\u30B7\u30B9\u30C6\u30E0\u30EA\u30D7\u30EC\u30A4\u30B9",
                        en: "SaaS replacement"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "\u9045\u5EF6\u5C40\u9762\u304B\u3089\u53C2\u753B\u3002\u30DE\u30B9\u30BF\u30FC\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u30FBWBS\u30FB\u7DCF\u5408\u30C6\u30B9\u30C8\u30B7\u30CA\u30EA\u30AA\u3092\u6574\u5099",
                        en: "Joined mid-delay; rebuilt master schedule, WBS, and integration-test scenarios"
                    }
                }
            ]
        },
        {
            id: "mahmoud",
            image: "team-mahmoud.png",
            role: {
                ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF\u30A8\u30F3\u30B8\u30CB\u30A2",
                en: "Full-stack engineer"
            },
            name: {
                ja: "MAHMOUD DABBAGH",
                en: "MAHMOUD DABBAGH"
            },
            reading: {
                ja: "\u30DE\u30D5\u30E0\u30FC\u30C9\u30FB\u30C0\u30C3\u30D0\u30B0",
                en: "Mahmoud Dabbagh"
            },
            age: {
                ja: "",
                en: ""
            },
            tags: {
                ja: [
                    "AWS",
                    "Docker",
                    "\u6A5F\u68B0\u5B66\u7FD2",
                    "\u30C7\u30FC\u30BF\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3"
                ],
                en: [
                    "AWS",
                    "Docker",
                    "Machine learning",
                    "Data pipelines"
                ]
            },
            bio: {
                ja: [
                    "\u5728\u5B66\u4E2D\u304B\u3089\u8907\u6570IT\u4F01\u696D\u3067\u5B66\u751F\u30A4\u30F3\u30BF\u30FC\u30F3\u3068\u3057\u3066\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF\u30A8\u30F3\u30B8\u30CB\u30A2\u7D4C\u9A13",
                    "AI\u958B\u767A\u30B9\u30BF\u30FC\u30C8\u30A2\u30C3\u30D7\u3067AI\u958B\u767A\u30CE\u30A6\u30CF\u30A6\u3092\u84C4\u7A4D",
                    "4\u304B\u56FD\u8A9E\u3092\u64CD\u308A\u3001\u591A\u6587\u5316\u74B0\u5883\u3067\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u63A8\u9032\u304C\u53EF\u80FD"
                ],
                en: [
                    "Student internships as full-stack engineer at multiple IT firms",
                    "AI startup\u2014production ML and data pipelines",
                    "Quadrilingual\u2014comfortable leading in multicultural teams"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "IT\u696D\u754C",
                        en: "IT"
                    },
                    theme: {
                        ja: "\u30C7\u30FC\u30BF\u57FA\u76E4\u958B\u767A",
                        en: "Data platform"
                    },
                    role: {
                        ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF",
                        en: "Full-stack"
                    },
                    detail: {
                        ja: "\u8A2D\u8A08\u301C\u69CB\u7BC9\u301C\u904B\u7528\u3001\u30C7\u30FC\u30BF\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u304A\u3088\u3073\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u5206\u6790\u57FA\u76E4",
                        en: "Design, build, ops\u2014pipelines and analytics foundation"
                    }
                },
                {
                    client: {
                        ja: "IT\u696D\u754C",
                        en: "IT"
                    },
                    theme: {
                        ja: "\u30D7\u30ED\u30C0\u30AF\u30C8\u6539\u4FEE",
                        en: "Product work"
                    },
                    role: {
                        ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF",
                        en: "Full-stack"
                    },
                    detail: {
                        ja: "Docker\u958B\u767A\u74B0\u5883\u3001AWS\u30A4\u30F3\u30D5\u30E9\u69CB\u7BC9\u30FB\u904B\u7528",
                        en: "Docker dev envs and AWS infra"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u57FA\u5E79\u30B7\u30B9\u30C6\u30E0\u30EA\u30D7\u30EC\u30A4\u30B9",
                        en: "ERP replacement"
                    },
                    role: {
                        ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF",
                        en: "Full-stack"
                    },
                    detail: {
                        ja: "\u65E2\u5B58\u57FA\u5E79\u3092Web\u30B7\u30B9\u30C6\u30E0\u3068\u3057\u3066\u30EA\u30D7\u30EC\u30A4\u30B9",
                        en: "Legacy ERP to modern web stack"
                    }
                },
                {
                    client: {
                        ja: "\u793E\u5185",
                        en: "Internal"
                    },
                    theme: {
                        ja: "\u753B\u50CF\u8A8D\u8B58AI PoC",
                        en: "Vision AI PoC"
                    },
                    role: {
                        ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF",
                        en: "Full-stack"
                    },
                    detail: {
                        ja: "\u30DB\u30EF\u30A4\u30C8\u30A2\u30A6\u30C8\u52D5\u753B\u304B\u3089\u7269\u4F53\u691C\u51FA\u3001\u30E2\u30C7\u30EB\u84B8\u7559\u3067Android\u8EFD\u91CF\u5316",
                        en: "Detection on washed-out video; distilled models for Android"
                    }
                }
            ]
        },
        {
            id: "ishibashi",
            image: "team-ishibashi.png",
            role: {
                ja: "PM / \u55B6\u696D",
                en: "PM & sales"
            },
            name: {
                ja: "\u77F3\u6A4B \u5EC9",
                en: "Ren Ishibashi"
            },
            reading: {
                ja: "\u3044\u3057\u3070\u3057 \u308C\u3093",
                en: "Ren Ishibashi"
            },
            age: {
                ja: "30\u6B73",
                en: "30"
            },
            tags: {
                ja: [
                    "M365 / Copilot",
                    "\u751F\u6210AI\u63D0\u6848",
                    "\u57FA\u5E79\u30EA\u30D7\u30EC\u30A4\u30B9",
                    "SNS\u30DE\u30FC\u30B1"
                ],
                en: [
                    "M365 / Copilot",
                    "GenAI proposals",
                    "ERP replacement",
                    "SNS marketing"
                ]
            },
            bio: {
                ja: [
                    "\u4E0D\u598A\u6280\u5E2B\u3068\u3057\u3066\u9AD8\u5EA6\u751F\u6B96\u88DC\u52A9\u533B\u7642\u306B\u8CA2\u732E\u3057\u3001\u7CFB\u5217\u75C5\u9662\u306E\u7ACB\u3061\u4E0A\u3052\u306B\u53C2\u753B",
                    "\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u4F1A\u793E\u3078\u8EE2\u8077\u3057\u3001\u55B6\u696D\u8077\u3068\u3057\u3066\u7D4C\u9A13\u3092\u7A4D\u3080",
                    "\u9867\u5BA2\u6298\u885D\u80FD\u529B\u3092\u6D3B\u304B\u3057\u3001PM\u3068\u3057\u3066\u958B\u767A\u696D\u52D9\u3092\u63A8\u9032",
                    "M365\uFF08Copilot\uFF09\u306E\u77E5\u8B58\u3092\u6D3B\u304B\u3057\u3001\u55B6\u696D\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u3068\u3057\u3066\u8CA9\u793E\u652F\u63F4\u3092\u884C\u3046"
                ],
                en: [
                    "Clinical embryologist in advanced reproductive medicine; helped launch an affiliated hospital",
                    "Moved to a systems integrator in a sales role",
                    "PM leveraging strong client communication",
                    "Sales consultant supporting partners with M365 and Copilot"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u4E8B\u696D\u4F1A\u793E\u30FB\u793E\u56E3\u6CD5\u4EBA\u7B49",
                        en: "Enterprises & associations"
                    },
                    theme: {
                        ja: "\u751F\u6210AI\u30B5\u30FC\u30D3\u30B9\u63D0\u6848",
                        en: "GenAI services"
                    },
                    role: {
                        ja: "\u55B6\u696D",
                        en: "Sales"
                    },
                    detail: {
                        ja: "\u751F\u6210AI\u30B5\u30FC\u30D3\u30B9\u3092\u5FB9\u5E95\u30EA\u30B5\u30FC\u30C1\u3057\u3001\u4E8B\u696D\u6A5F\u4F1A\u3092\u767A\u6398\u3002\u6700\u9069\u306A\u30D3\u30B8\u30CD\u30B9\u30E2\u30C7\u30EB\u3092\u8003\u616E\u3057\u305F\u63D0\u6848",
                        en: "Market scan and business-model proposals for GenAI opportunities"
                    }
                },
                {
                    client: {
                        ja: "\u793E\u5185",
                        en: "Internal"
                    },
                    theme: {
                        ja: "SNS\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
                        en: "SNS marketing"
                    },
                    role: {
                        ja: "\u30DE\u30FC\u30B1",
                        en: "Marketing"
                    },
                    detail: {
                        ja: "YouTube/X/LinkedIn\u65BD\u7B56\u4F01\u753B\u30FB\u5B9F\u884C\u3001\u793E\u5916\u4EA4\u6E09",
                        en: "YouTube/X/LinkedIn programs and vendor coordination"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u55B6\u696D",
                        en: "Sales"
                    },
                    role: {
                        ja: "\u55B6\u696D",
                        en: "Sales"
                    },
                    detail: {
                        ja: "\u30D2\u30A2\u30EA\u30F3\u30B0\u304B\u3089\u63D0\u6848\u8CC7\u6599\u4F5C\u6210\u30FB\u6210\u7D04\u30023000\u4E07\u5186\u898F\u6A21\u306E\u5927\u578B\u6848\u4EF6",
                        en: "Discovery to close\u2014\xa530M deal"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u57FA\u5E79\u30B7\u30B9\u30C6\u30E0\u30EA\u30D7\u30EC\u30A4\u30B9",
                        en: "ERP replacement"
                    },
                    role: {
                        ja: "PM",
                        en: "PM"
                    },
                    detail: {
                        ja: "\u8981\u4EF6\u6574\u7406\u301C\u57FA\u672C\u8A2D\u8A08\u300110\u4EBA\u958B\u767A\u30C1\u30FC\u30E0\u7D71\u7387",
                        en: "Requirements through basic design; 10-person squad"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "M365\u30FBCopilot\u5C0E\u5165\u30FB\u904B\u7528\u652F\u63F4",
                        en: "M365 & Copilot adoption"
                    },
                    role: {
                        ja: "\u55B6\u696D\u30B3\u30F3\u30B5\u30EB",
                        en: "Sales consultant"
                    },
                    detail: {
                        ja: "\u5C0E\u5165\u30FB\u904B\u7528\u652F\u63F4\u3001\u63D0\u6848\u8CC7\u6599\u4F5C\u6210\u3001\u30C7\u30E2\u30FB\u30BB\u30DF\u30CA\u30FC\u306B\u3088\u308B\u8CA9\u58F2\u4FC3\u9032",
                        en: "Adoption support, proposals, demos, and partner enablement seminars"
                    }
                }
            ]
        },
        {
            id: "nogami",
            image: "team-nogami.png",
            role: {
                ja: "PM / PMO",
                en: "PM / PMO"
            },
            name: {
                ja: "\u91CE\u4E0A \u62D3\u6689",
                en: "Hiroki Nogami"
            },
            reading: {
                ja: "\u306E\u304C\u307F \u3072\u308D\u304D",
                en: "Hiroki Nogami"
            },
            age: {
                ja: "29\u6B73",
                en: "29"
            },
            tags: {
                ja: [
                    "\u5C0F\u58F2\u30FB\u5E97\u8217\u958B\u767A",
                    "\u57FA\u5E79\u30EA\u30D7\u30EC\u30A4\u30B9",
                    "\u30AF\u30E9\u30A6\u30C9\u79FB\u884C",
                    "SNS\u30DE\u30FC\u30B1"
                ],
                en: [
                    "Retail expansion",
                    "ERP replacement",
                    "Cloud migration",
                    "SNS marketing"
                ]
            },
            bio: {
                ja: [
                    "\u5BB6\u5177\u30E1\u30FC\u30AB\u30FC\u306E\u55B6\u696D\u3068\u3057\u3066\u3001\u65E2\u5B58\u9867\u5BA2\u3092\u4E2D\u5FC3\u3068\u3057\u305F\u30EB\u30FC\u30C8\u55B6\u696D\u306B\u5F93\u4E8B",
                    "\u8CA9\u58F2\u5E97\u3078\u306E\u63D0\u6848\u304B\u3089\u7D0D\u54C1\u5F8C\u30D5\u30A9\u30ED\u30FC\u307E\u3067\u4E00\u8CAB\u5BFE\u5FDC\u3057\u3001\u9577\u671F\u7684\u306A\u95A2\u4FC2\u69CB\u7BC9\u306B\u8CA2\u732E",
                    "\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u4F1A\u793E\u3078\u8EE2\u8077\u3057\u55B6\u696D\u7D4C\u9A13\u5F8C\u3001\u554F\u984C\u89E3\u6C7A\u578B\u306E\u55B6\u696D\u7D4C\u9A13\u3092\u6D3B\u304B\u3057PM\u3068\u3057\u3066\u958B\u767A\u3092\u63A8\u9032"
                ],
                en: [
                    "Furniture maker sales\u2014route accounts focused on existing retailers",
                    "End-to-end proposals through post-delivery follow-up and long-term relationships",
                    "Systems integrator sales, then PM leveraging problem-solving sales experience"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u5C0F\u58F2\u696D",
                        en: "Retail"
                    },
                    theme: {
                        ja: "\u30AA\u30EA\u30B8\u30CA\u30EB\u30D6\u30E9\u30F3\u30C9\u5E97\u8217\u5C55\u958B",
                        en: "Brand store rollout"
                    },
                    role: {
                        ja: "\u55B6\u696D/PM",
                        en: "Sales/PM"
                    },
                    detail: {
                        ja: "\u5168\u56FD19\u5E97\u8217\u306E\u3046\u30616\u5E97\u8217\u7ACB\u3061\u4E0A\u3052\u3002\u58F2\u4E0A3.9\u5104\u5186\u306E\u3046\u3061\u7D041.45\u5104\u5186\u3092\u9054\u6210",
                        en: "Led 6 of 19 national openings; \xa5145M of \xa5390M program revenue"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "\u57FA\u5E79\u30B7\u30B9\u30C6\u30E0\u30EA\u30D7\u30EC\u30A4\u30B9",
                        en: "ERP replacement"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "\u8981\u4EF6\u6574\u7406\u301C\u57FA\u672C\u8A2D\u8A08\u300110\u4EBA\u30C1\u30FC\u30E0\u306E\u9032\u6357\u7BA1\u7406\u30B5\u30DD\u30FC\u30C8",
                        en: "Requirements through basic design; squad progress PMO"
                    }
                },
                {
                    client: {
                        ja: "\u901A\u4FE1\u696D",
                        en: "Telecom"
                    },
                    theme: {
                        ja: "\u57FA\u5E79\u30B7\u30B9\u30C6\u30E0\u30AF\u30E9\u30A6\u30C9\u79FB\u884C",
                        en: "Core system cloud migration"
                    },
                    role: {
                        ja: "PMO",
                        en: "PMO"
                    },
                    detail: {
                        ja: "\u30AA\u30F3\u30D7\u30EC\u304B\u3089\u30AF\u30E9\u30A6\u30C9\u3078\u306E\u79FB\u884C\u5F8C\u3001\u5B89\u5B9A\u7A3C\u50CD\u306B\u5411\u3051\u305F\u904B\u7528\u4F53\u5236\u30FB\u554F\u3044\u5408\u308F\u305B\u5BFE\u5FDC\u3092\u652F\u63F4",
                        en: "Post-migration ops readiness, inquiry handling, and process adoption"
                    }
                },
                {
                    client: {
                        ja: "\u793E\u5185",
                        en: "Internal"
                    },
                    theme: {
                        ja: "SNS\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
                        en: "SNS marketing"
                    },
                    role: {
                        ja: "\u30DE\u30FC\u30B1",
                        en: "Marketing"
                    },
                    detail: {
                        ja: "YouTube/X/LinkedIn\u65BD\u7B56\u3001\u793E\u5916\u62C5\u5F53\u8005\u3068\u306E\u4EA4\u6E09",
                        en: "Social programs and external partner coordination"
                    }
                }
            ]
        },
        {
            id: "nguyen",
            image: "team-nguyen.png",
            role: {
                ja: "\u30B7\u30B9\u30C6\u30E0\u30A8\u30F3\u30B8\u30CB\u30A2",
                en: "Software engineer"
            },
            name: {
                ja: "NGUYEN CHAM",
                en: "NGUYEN CHAM"
            },
            reading: {
                ja: "\u30B0\u30A7\u30F3 \u30C1\u30E3\u30E0",
                en: "Nguyen Cham"
            },
            age: {
                ja: "",
                en: ""
            },
            tags: {
                ja: [
                    "Ruby",
                    "React",
                    "Vue",
                    "TypeScript"
                ],
                en: [
                    "Ruby",
                    "React",
                    "Vue",
                    "TypeScript"
                ]
            },
            bio: {
                ja: [
                    "\u5EFA\u8A2D\u8CC7\u6750\u5546\u793E\u3001\u98DF\u54C1\u88FD\u9020\u3001IT\u4F01\u696D\u3067\u7D4C\u7406\u30FB\u7DCF\u52D9\u30FB\u5916\u56FD\u4EBA\u5F93\u696D\u54E1\u30B5\u30DD\u30FC\u30C8\u7B49\u3092\u7D4C\u9A13",
                    "\u30B7\u30B9\u30C6\u30E0\u30A8\u30F3\u30B8\u30CB\u30A2\u3068\u3057\u3066Web\u30B7\u30B9\u30C6\u30E0\u306E\u4FDD\u5B88\u30FB\u904B\u7528\u30FB\u6539\u4FEE\u306B\u5F93\u4E8B",
                    "Ruby/Rails\u3001PHP\u3001Vue\u3001React\u3001TypeScript\u3002Docker/Git/GitHub/Bitbucket\u904B\u7528\u7D4C\u9A13"
                ],
                en: [
                    "Accounting, HR, and expat support across construction, food, and IT firms",
                    "Maintains and enhances web systems as SE",
                    "Ruby/Rails, PHP, Vue, React, TS; Docker and Git workflows"
                ]
            },
            projects: [
                {
                    client: {
                        ja: "\u5EFA\u8A2D\u8CC7\u6750\u5546\u793E",
                        en: "Construction supply"
                    },
                    theme: {
                        ja: "\u7D4C\u7406\u30FB\u8ECA\u4E21\u904B\u884C\u7BA1\u7406",
                        en: "Finance & fleet"
                    },
                    role: {
                        ja: "\u30E1\u30F3\u30D0\u30FC",
                        en: "Member"
                    },
                    detail: {
                        ja: "\u7D66\u4E0E\u8A08\u7B97\u3001\u5EFA\u8A2D\u8CC7\u6750\u904B\u642C\u8ECA\u4E21\u306E\u914D\u8ECA\u8ABF\u6574\u30FB\u904B\u884C\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u7BA1\u7406",
                        en: "Payroll plus construction-fleet dispatch and scheduling"
                    }
                },
                {
                    client: {
                        ja: "\u98DF\u54C1\u88FD\u9020\u696D",
                        en: "Food manufacturing"
                    },
                    theme: {
                        ja: "\u5916\u56FD\u4EBA\u5F93\u696D\u54E1\u30B5\u30DD\u30FC\u30C8",
                        en: "Expat support"
                    },
                    role: {
                        ja: "\u30E1\u30F3\u30D0\u30FC",
                        en: "Member"
                    },
                    detail: {
                        ja: "\u6280\u80FD\u5B9F\u7FD2\u30FB\u7279\u5B9A\u6280\u80FD\u306E\u901A\u8A33\u7FFB\u8A33\u3001\u5728\u7559\u624B\u7D9A\u304D\u3001\u5165\u793E\u30FB\u751F\u6D3B\u30FB\u793E\u54E1\u5BEE\u7BA1\u7406",
                        en: "Interpretation, visas, onboarding, housing, and dorm management"
                    }
                },
                {
                    client: {
                        ja: "\u88FD\u9020\u696D",
                        en: "Manufacturing"
                    },
                    theme: {
                        ja: "Web\u30B7\u30B9\u30C6\u30E0\u4FDD\u5B88\u904B\u7528",
                        en: "Web maintenance"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "Ruby/Rails/SQL\u3067\u4FDD\u5B88\u30FB\u6539\u4FEE\u30FB\u4E0D\u5177\u5408\u8ABF\u67FB",
                        en: "Rails/SQL maintenance and defect fixes"
                    }
                },
                {
                    client: {
                        ja: "\u30A2\u30D1\u30EC\u30EB\u696D\u754C",
                        en: "Apparel"
                    },
                    theme: {
                        ja: "EC Web\u6539\u4FEE",
                        en: "E-commerce web"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "Vue.js/JS/PostgreSQL\u3067\u6A5F\u80FD\u8FFD\u52A0\u30FB\u6539\u5584",
                        en: "Vue/JS/Postgres feature work"
                    }
                },
                {
                    client: {
                        ja: "\u5C0F\u58F2\u696D\u754C",
                        en: "Retail"
                    },
                    theme: {
                        ja: "Web\u4FDD\u5B88\u30FB\u6539\u5584",
                        en: "Web enhancement"
                    },
                    role: {
                        ja: "\u30A8\u30F3\u30B8\u30CB\u30A2",
                        en: "Engineer"
                    },
                    detail: {
                        ja: "React/TS\u30D5\u30ED\u30F3\u30C8\u3001\u30D0\u30C3\u30AF\u30A8\u30F3\u30C9\u9023\u643A\u3001Docker/Sandbox\u3001Git\u30C1\u30FC\u30E0\u958B\u767A\u30B5\u30DD\u30FC\u30C8",
                        en: "React/TS front-end, backend integration, Docker sandbox, and Git collaboration"
                    }
                }
            ]
        }
    ]
};

//# sourceMappingURL=team.8d971ce6.js.map
